import { UsersList } from './UsersList';
import { UserCreate } from './UserCreate';
import { UserEdit } from './UserEdit';
import { IconApps } from '../ui/icons';

export const users = {
    icon: IconApps,
    list: UsersList,
    create: UserCreate,
    edit: UserEdit,
};

export * from './UserCreateForm';
export * from './UserCreateToolbar';
